import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForPurchases = () => {
  return {
    purchase_subtypes:[],
    gerenate_po_codes:[],
    purchase_orders: [],
    document:{},
    po_list:[],
    grn_list:[],
    po_items:[],
    purchase_invoices: [],
    is_updated:null,
    is_created:null,
    generated_pi_codes:[],
    filter:{
      keyword:"",
      date_from:null,
      date_to:null,
      type:null,
      status:'ALL'
    },

  }
}

// state
const state = getDefaultStateForPurchases()

const getters = {

}

// mutations
const mutations = {
  SET_GENERATED_PO_CODE (state, data) {
    state.gerenate_po_codes = data
  },
  SET_GENERATED_PI_CODE (state, data) {
    state.generated_pi_codes = data
  },
  FETCH_ALL(state, { data, type })
  {
    if(data)
    {
      if(type == 'PO')
      {
        state.purchase_orders = data
      }
      else if(type == 'PI')
      {
        state.purchase_invoices = data
      }
    }
  },
  SET_PO_LISTS_FOR_GRN(state, data){
    state.po_list = data
  },
  RESET_STATE_FOR_COUNTRIES (state) {
    Object.assign(state, getDefaultStateForPurchases())
  },
  SET_IS_CREATED(state, data)
  {
    state.is_created = data
  },
  SET_IS_UPDATED(state, data)
  {
    state.is_updated = data
  },
  SET_FILTER(state, data)
  {
    state.filter = data
  },
  SET_GRN_LISTS_FOR_PI(state, data){
    state.grn_list = data
  },
  FETCH(state, data) {
    if(data)
    {
      state.document = data
    }
  },
  SET_PO_ITEMS(state, data){
    data.forEach(function(element) {
        element.allocate_qty =  element.balance_qty
    });
    state.po_items = data
  },
  SET_PURCHASE_SUBTYPES(state, data){
    state.purchase_subtypes = data
  }
}

// actions
const actions = {
  generatePurchaseForTradeItems({ commit }, data) {
    return axios.post(apiRoutes['GENERATE_PO_FOR_TRADE_ITEMS'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
              commit('SET_GENERATED_PO_CODE', response.data.data.pos)
            } 
            else 
            {
              commit('SET_GENERATED_PO_CODE', [])
              Vue.notify({
                group: 'notify',
                type: 'error',
                text: response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300
            })
            }
        })
        .catch(error => {
            commit('SET_GENERATED_PO_CODE', null)
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
      });
  },
  generateInvoiceFromGRN({ commit }, data) {
    return axios.post(apiRoutes['GENERATE_INVOICE_FROM_GRNS'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
              commit('SET_GENERATED_PI_CODE', response.data.data.invoices)
            } 
            else 
            {
              commit('SET_GENERATED_PI_CODE', [])
            }
        })
        .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
      });
  },
  fetchGRNsForPI({ commit }, data) {
    return axios.post(apiRoutes['LIST_GRNS_FOR_PI'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_GRN_LISTS_FOR_PI', response.data.data)
          } 
          else 
          {
            commit('SET_GRN_LISTS_FOR_PI', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  setGRNList({commit}, data){
    commit('SET_GRN_LISTS_FOR_PI', [])
  },
  fetchPoItems({ commit }, data) {
    return axios.post(apiRoutes['RETRIEVE_PO_ITEMS'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_PO_ITEMS', response.data.data)
          } 
          else 
          {
            commit('SET_PO_ITEMS', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetchPosForGRN({ commit }, data) {
    return axios.post(apiRoutes['LIST_POS_FOR_GRN'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_PO_LISTS_FOR_GRN', response.data.data)
          } 
          else 
          {
            commit('SET_PO_LISTS_FOR_GRN', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetch({ commit }, data) {
    let apiUrl = null;
      if(data.type == 'PO')
      {
        apiUrl = apiRoutes['PURCAHSE_RETRIEVE_ORDER']
      }
      else if(data.type == 'PI')
      {
        apiUrl = apiRoutes['PURCAHSE_RETRIEVE_INVOICE']
      } 
      return axios.post(apiUrl, data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  async create({ commit, dispatch }, data) {
    let apiCreatePurchaseDocument  = '';
    if(data['type'] == 'PO')
      apiCreatePurchaseDocument = apiRoutes['CREATE_PURCHASE_ORDER']
    else if(data['type'] == 'PI')
      apiCreatePurchaseDocument = apiRoutes['CREATE_PURCHASE_INVOICE']

    //alert(apiCreatePurchaseDocument)

    await axios.post(apiCreatePurchaseDocument, data, authHeader())
        .then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code
            Vue.notify({
                group: 'notify',
                type: 'success',
                text: 'Purchase (' + doc_number + ')' + " has been created!",
                max: 5,
                duration: 5000,
                speed: 300
            })

            commit('SET_IS_CREATED', 1);
          }
          else
          {
              let errors = response.data.data.errors
                  
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
              }
              commit('SET_IS_CREATED', 0);
          }

        })
        .catch((error) => {
            // alert(error)
            // console.log(error.response)

            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Application exception")
            }
        });
  },
  getPurchaseSubTypes({ commit }, data) 
  {
      return axios.post(apiRoutes['GET_PURCHASE_SUBTYPES'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_PURCHASE_SUBTYPES', response.data.data)
            } else {
              commit('SET_PURCHASE_SUBTYPES', [])
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  resetState({ commit, dispatch }, payload) {
    commit("RESET_STATE_FOR_COUNTRIES")
  },
  quickSearch({ commit }, data) {
      return axios.post(apiRoutes['PURCHASE_QUICK_SEARCH'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH_ALL', {data:response.data.data, type:data.type})
              commit('SET_FILTER', data)
            } 
            else 
            {
              commit('FETCH_ALL', {data:[], type:null})
              commit('SET_FILTER', data)
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  async update({ commit, dispatch }, data) 
  {
    let apiUrl  = '';
    if(data['type'] == 'PO')
      apiUrl = apiRoutes['UPDATE_PURCHASE_ORDER']
    else if(data['type'] == 'PI')
      apiUrl = apiRoutes['UPDATE_PURCHASE_INVOICE']

    await axios.post(apiUrl, data, authHeader()).then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code
            Vue.notify({
                group: 'notify',
                type: 'success',
                text: 'Purchase (' + doc_number + ')' + " has been updated!",
                max: 5,
                duration: 5000,
                speed: 300
            })
            commit('SET_IS_UPDATED', 1);
          }
          else
          {
              let errors = response.data.data.errors
                  
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
              }
              commit('SET_IS_UPDATED', 0);
          }
        })
        .catch((error) => {
            // alert(error)
            // console.log(error.response)

            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Problem Creating Purchase")
            }
        });
  },
}

export {
    state,
    getters,
    actions,
    mutations
}
